const config = {
  SERVER_URL: "",  // kosong = relative URL (pakai domain yang sama)
  ADMIN_KEY: "habaib",
};

export default config;
